<template>
  <AwAvatar v-if="hasName(teamMember)" :text="getFullName(teamMember)" :size="size ?? 'md'" />
  <AwAvatar v-else :text="teamMember.email ?? ''" :size="size ?? 'md'" />
</template>

<script setup lang="ts">
import type { AwAvatarSize as AvatarSize } from "@asap/design";
import { getFullName, hasName } from "@asap/shared/utils/people";
import type { TeamMemberForAvatar } from "@asap/shared/utils/supabase.types";

const props = defineProps<{
  teamMember: Partial<TeamMemberForAvatar>;
  size?: AvatarSize;
}>();

const { teamMember } = toRefs(props);
</script>
